var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 137.52 143.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#fff;}.cls-5{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.56,
    y: 0.34,
    width: 136.09,
    height: 141.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,18.86a61.7,61.7,0,0,0-7.14,123H82.05A61.78,61.78,0,0,0,136.49,85v-8.8A61.79,61.79,0,0,0,75,18.86h0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.55,18.86a61.7,61.7,0,0,0-7.13,123h14.23A61.78,61.78,0,0,0,287.08,85v-8.8a61.75,61.75,0,0,0-61.52-57.3h0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.05,22.17a61.68,61.68,0,1,1-38.48,78.28A61.68,61.68,0,0,1,55.05,22.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.05,22.17a61.68,61.68,0,1,1-38.48,78.28A61.68,61.68,0,0,1,55.05,22.17"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.49,73.64a.11.11,0,0,1,.08,0s-.08,0-.08,0m4-1.32c-.12,0-2.2.79-3.33,1.14.44-3.78,1.57-8.18-.56-11.77-2.83-4.35-9-1.74-11.44,1.68a45.6,45.6,0,0,0-4.57,7.41c-.06-.22-.13-.43-.2-.65-1.73-5.56-9-4.74-12-.83a38.6,38.6,0,0,0-4.82,7.33,11.16,11.16,0,0,0-1-2.08c-3.08-4.68-9.7-2.28-12.33,1.59-7.18,8-11.69,30.8-21,35.18,0-10.37,3.57-20.64,5.66-30.8,2.36-9.86,6-23.74,8.52-33.73h0c1.08-3.82-4.92-5.38-5.87-1.56-3.35,12.74-7,25.42-10.06,38.23a36.32,36.32,0,0,1-6.27,11.4c-7.66,8.47-19.68,12.33-30.19,16.62C-9.65,117.93-26.5,124.12-43,131c15.9-5.15,35.44-11.23,51.25-16.44,11.11-4,23.4-7.37,32-16-.41,2.07-.8,4.16-1.15,6.24-3.5,15.74,8.43,17.6,16.4,6.1,4.27-6.21,7-13.24,10-20,2.24-4.36,4.44-13,8.41-13,3.52,0,.88,6.61,0,11a3,3,0,0,0,5.63,1.6c2.39-4,6.69-18.79,11.11-18.79,3.52,0,1.32,7.49.57,10.51s4,4.28,5.21,1.46c3.2-5.89,7.44-19,11-19,2.91-.09,1.78,5.07,1.32,7.93-.69,4.36,1.09,6.51,5.41,5,25.55-9.79,52.7-20.15,78.08-30.35-24.74,7.83-51.11,16.61-75.69,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.64,76.48a3.3,3.3,0,0,1-1.09-6.42l18.78-6.57a3.3,3.3,0,0,1,2.19,6.23L41.73,76.3a3.46,3.46,0,0,1-1.09.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.65,60.77a4.41,4.41,0,1,1-4.4-4.41,4.41,4.41,0,0,1,4.4,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.84,54.6a4.41,4.41,0,1,1-4.41-4.4,4.41,4.41,0,0,1,4.41,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114,48.43a4.41,4.41,0,1,1-4.41-4.4,4.4,4.4,0,0,1,4.41,4.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.08,73.64a.11.11,0,0,1,.08,0s-.07,0-.08,0m4.05-1.32c-.12,0-2.2.79-3.33,1.14.44-3.78,1.57-8.18-.56-11.77-2.84-4.35-9.05-1.74-11.44,1.68a44.25,44.25,0,0,0-4.57,7.41c-.07-.22-.13-.43-.21-.65-1.73-5.56-9-4.74-12-.83a38.13,38.13,0,0,0-4.82,7.33,12.61,12.61,0,0,0-1-2.08c-3.08-4.68-9.7-2.28-12.34,1.59-7.18,8-11.68,30.8-21,35.18,0-10.37,3.56-20.64,5.65-30.8,2.37-9.86,6-23.74,8.52-33.73h0c1.09-3.82-4.91-5.38-5.86-1.56-3.36,12.74-7,25.42-10.07,38.23a36.3,36.3,0,0,1-6.26,11.4c-7.66,8.47-19.69,12.33-30.19,16.62C141,117.93,124.09,124.12,107.55,131c15.89-5.15,35.44-11.23,51.25-16.44,11.11-4,23.4-7.37,32-16-.4,2.07-.79,4.16-1.15,6.24-3.5,15.74,8.43,17.6,16.4,6.1,4.28-6.21,7-13.24,10.05-20,2.24-4.36,4.45-13,8.41-13,3.53,0,.88,6.61,0,11a3,3,0,0,0,5.63,1.6c2.39-4,6.7-18.79,11.11-18.79,3.53,0,1.33,7.49.58,10.51s4,4.28,5.21,1.46c3.19-5.89,7.43-19,11-19,2.9-.09,1.77,5.07,1.32,7.93-.7,4.36,1.09,6.51,5.41,5,25.55-9.79,52.7-20.15,78.08-30.35-24.74,7.83-51.11,16.61-75.69,25"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.66092159a15570fd389c1f076daf9587.svg";
export { ForwardRef as ReactComponent };